export const knowHowData: { id: number; text: string }[] = [
  {
    id: 1,
    text: "팀스파르타는 매년 순이익을 내고 있는 흔치 않은 스타트업입니다. 2022년, 3년 만에 130억 규모의 시리즈 A 투자를 유치하고, 올해는 연 매출 450억을 바라보고 있습니다.",
  },
  {
    id: 2,
    text: "그로스 해킹에 기반한 팀스파르타만의 빠르고 효과적인 마케팅 전략은 투자없이 100억의 흑자를 가능하게 한 핵심요소입니다.",
  },
  {
    id: 3,
    text: "그로스 해킹부터 브랜드 캠페인, 콘텐츠 제작까지. 마케팅의 정수를 3개월간 압축하여 전달합니다.",
  },
];
